import React, { memo } from 'react'

const Filters = (props) => {
  return (

    <div className="lg:bg-creamLight lg:rounded-2xl py-6 px-5 xl:px-9 mb-5">
      <div className="mb-4 text-lg text-gray-800 font-bold">
        <h3>{props?.title}</h3>
      </div>
      {props?.data?.map((item, index) => (
        <div
          key={item.id}
          className={`flex items-center form-check font-normal focus:outline-none hover:font-black hover:text-primary leading-tight outline-none pb-4 
              ${props?.filterSelected === item?.slug ? 'text-primary font-black' : 'text-font-primary'}`}

        >
          <input
            type="radio"
            id={item?.id}
            name={item?.name}
            value={item?.slug}
            checked={props?.filterSelected === item?.slug}
            readOnly
            className="bg-creamDark appearance-none rounded h-5 w-5 radioBtn border  transition duration-200 align-top bg-no-repeat bg-center bg-contain mr-4 cursor-pointer flex-shrink-0"
            onClick={() => { props.handleClick(item) }}
          />
          <label
            htmlFor={item?.id}
            className={`font-normal focus:outline-none hover:font-black hover:text-primary leading-tight outline-none cursor-pointer
                ${props?.filterSelected === item?.slug ? 'text-primary font-black' : 'text-font-primary'}`}
          >
            {item?.name}
          </label>
        </div>

      ))}
    </div>
  )
}

export default memo(Filters)